import AnimatorConflicts from "../../../../../components/Meetings/AnimatorConflicts";
import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";
import { LanguageKeys, VisibilityKeys } from "./CreateMeetingModal.d";

export const visibilityOptions = (language: string): Record<VisibilityKeys, string> => ({
  shared: translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.CREATE_MODAL.OPTIONS.VISIBILITY.SHARED"),
  private: translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.CREATE_MODAL.OPTIONS.VISIBILITY.PRIVATE"),
});

export const languageMapping = (language: string): Record<LanguageKeys, string> => ({
  "fr-FR": translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.CREATE_MODAL.OPTIONS.LANGUAGE.FRENCH"),
  "en-US": translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.CREATE_MODAL.OPTIONS.LANGUAGE.ENGLISH"),
});

export const getMeetingTypes = (setMeetingTypes: Function, setLoading: Function, language: string) => {
  setLoading((loading: any) => ({ ...loading, types: true }));
  ApiService.get("meetings/types")
    .then((response) => setMeetingTypes(response.data.meeting_types))
    .catch((err) => {
      console.error("Error fetching meeting types:", err);
      alert(translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.CREATE_MODAL.ERRORS.FETCH_MEETING_TYPES"));
    })
    .finally(() => setLoading((loading: any) => ({ ...loading, types: true })));
};

export const getResources = (setAnimators: Function, setPrograms: Function, setLoading: Function, language: string) => {
  setLoading((loading: any) => ({ ...loading, resources: true }));
  ApiService.get("meetings/resources?only_active_animators=true")
    .then((response) => {
      setAnimators(response.data.meeting_staff_and_programs.animators);
      setPrograms(response.data.meeting_staff_and_programs.programs);
    })
    .catch((error) => {
      console.error("Failed to get animators and programs:", error);
      alert(translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.CREATE_MODAL.ERRORS.GET_ADMINS"));
    })
    .finally(() => setLoading((loading: any) => ({ ...loading, resources: true })));
};

export const createMeeting = (
  payload: any,
  language: string,
  setLoading: Function,
  displayAlert: Function,
  setShowCreationModal: Function,
  resetSelection: Function,
  onSuccess: Function
) => {
  setLoading((loading: any) => ({ ...loading, submit: true }));
  ApiService.post("meetings", payload)
    .then((response) => {
      setShowCreationModal(false);

      const data = response.data;
      const meetingIds = data.meeting_id ? [data.meeting_id] : data.meeting_ids || [];

      if (data.animator_conflicts) {
        displayAlert({
          type: "warning",
          title: translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.DST_ALERT.WARNING.TITLE"),
          message: translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.DST_ALERT.WARNING.MESSAGE"),
          extraContent: <AnimatorConflicts conflicts={data.animator_conflicts} />,
          clickOutsideToClose: true,
          buttons: [
            {
              label: translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.MEETINGS.DST_ALERT.WARNING.OPEN_CONFLICTS"),
              variant: "secondary",
              onClick: () =>
                data.animator_conflicts
                  .flatMap((conflict: any) => conflict.conflicting_meetings.map((meeting: any) => meeting.id))
                  .forEach((id: string) => window.open(`/meeting/${id}`, "_blank")),
            },
          ],
        });
      } else {
        displayAlert({
          type: "success",
          title: translate(language, "PAGES.MEETINGS.DST_ALERT.SUCCESS.TITLE"),
          clickOutsideToClose: true,
          buttons: [
            {
              label: translate(language, "PAGES.MEETINGS.DST_ALERT.SUCCESS.OPEN_MEETINGS"),
              variant: "secondary",
              onClick: () => meetingIds.forEach((id: string) => window.open(`/meeting/${id}`, "_blank")),
            },
            {
              label: translate(language, "PAGES.MEETINGS.DST_ALERT.SUCCESS.CREATE_MEETING"),
              variant: "primary",
              onClick: () => setShowCreationModal(true),
            },
          ],
        });
      }

      resetSelection();
      onSuccess();
    })
    .catch((error) => {
      console.error("Error creating meeting:", error);
      setShowCreationModal(false);
      displayAlert({
        type: "danger",
        title: translate(language, "PAGES.MEETINGS.DST_ALERT.ERROR.TITLE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.MEETINGS.DST_ALERT.ERROR.TRY_AGAIN"),
            variant: "primary",
            onClick: () => setShowCreationModal(true),
          },
        ],
      });
    })
    .finally(() => setLoading((loading: any) => ({ ...loading, submit: false })));
};
